import { theme } from '@/utils/theme';

export const classes = {
  wrapper: 'mt-2 mb-4 place-start flex-col',
  title: 'font-medium text-grey-8 dark:text-mauve-1',
  list: 'max-h-[275px] overflow-y-auto',
  listItem: 'px-0 py-0',
  listItemButton: 'px-4 py-1 rounded-lg transition-colors duration-100 text-sm',
};

export const styles = {
  listItemButton: (isActive: boolean) => ({
    '&:hover': {
      color: theme.palette[isActive ? 'white' : 'grey-8'].main,
      backgroundColor: theme.palette[isActive ? 'orange-2' : 'grey-2'].main,
    },
    '&, &.Mui-focusVisible, &:focus': {
      color: theme.palette[isActive ? 'white' : 'grey-8'].main,
      backgroundColor: theme.palette[isActive ? 'orange-2' : 'white'].main,
    },
    ...(isActive
      ? {}
      : {
          '.dark &:hover': {
            color: theme.palette['mauve-1'].main,
            backgroundColor: 'rgba(255,255,255,0.06)',
          },
          '.dark &, .dark &.Mui-focusVisible, .dark &:focus': {
            color: theme.palette['mauve-1'].main,
            backgroundColor: 'transparent',
          },
        }),
  }),
};
